import React, { memo } from 'react';

import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  toolCallDetailStyles,
  toolCallLabelStyles,
  toolCallRowStyles,
  toolCallsContainerStyles,
} from './ToolCallsContent.styles';

const ToolCallsContent = ({ contentProps }) => {
  const { toolCalls } = contentProps;

  return (
    <Stack sx={toolCallsContainerStyles}>
      {toolCalls.map(call => {
        const hasDetail = _.isString(call.detail) && call.detail.length > 0;

        if (!hasDetail) {
          return (
            <Typography key={call.id} sx={toolCallLabelStyles} variant="regular14">
              {call.label}
            </Typography>
          );
        }

        return (
          <Accordion disableGutters key={call.id}>
            <AccordionSummary>
              <Stack sx={toolCallRowStyles}>
                <Typography sx={toolCallLabelStyles} variant="regular14">
                  {call.label}
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary" sx={toolCallDetailStyles} variant="regular12">
                {call.detail}
              </Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Stack>
  );
};

ToolCallsContent.propTypes = {
  contentProps: PropTypes.shape({
    toolCalls: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        detail: PropTypes.string,
      }),
    ).isRequired,
  }).isRequired,
};

export default memo(ToolCallsContent);
